import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';

import config from 'config';
import useAgent from 'hooks/useAgent';
import useAnalytics from 'hooks/useAnalytics';
import { formatPathForAnalytics } from 'utilities/helpers';

const SegmentProvider = (props) => {
  const location = useLocation();
  const agent = useAgent();
  const { trackPage, identifyUser, resetUser } = useAnalytics();
  const { customerId } = useParams();

  // Track each page change
  useEffect(() => {
    const page = formatPathForAnalytics(location.pathname);
    trackPage(page, { customerId });
  }, [location]);

  // Identify user
  useEffect(() => {
    if (agent.loaded) {
      identifyUser(agent.user?.requester_id, agent.user);
    } else {
      resetUser();
    }
  }, [agent]);

  return (
    <>
      <script
        async
        src={`https://cdn.segment.com/analytics.js/v1/${config.SEGMENT_KEY}/analytics.min.js`}
      />
      {props.children}
    </>
  );
};

export default SegmentProvider;
